import {unique} from 'shared/utils/unique';

export function connect(connected: Listeners, toConnect: Listeners): Listeners {
  return unique<Listener>([...connected, ...toConnect]);
}
